import {
  AUTH_TYPE_SELECTION,
  EMAIL_VERIFICATION_INFO,
  PHONE_VERIFICATION_INPUT,
  VERIFICATION_SUCCEEDED,
} from '../constants/studentSignupStages';
import * as authTypes from '../constants/authType';
import * as loadingState from '../constants/loadingState';
import { STUDENT } from '../constants/userRoles';
import { PHONE, EMAIL } from '../constants/signupAuthType';

/**
 * @TODO seperate facebook signup, normal signup into different reducer.
 */
export const ALTER_FACEBOOK_AUTH_TYPE = 'ALTER_FACEBOOK_AUTH_TYPE';

export const SWITCH_SIGNUP_ROLE = 'SWITCH_SIGNUP_ROLE';

export const STORE_SIGNUP_INFO = 'STORE_SIGNUP_INFO';

// Student FB signup actions
export const FACEBOOK_SIGNUP = 'FACEBOOK_SIGNUP';
export const FACEBOOK_SIGNUP_SUCCESS = 'FACEBOOK_SIGNUP_SUCCESS';
export const FACEBOOK_SIGNUP_FAILED = 'FACEBOOK_SIGNUP_FAILED';

// Incrementing the Signup Stage
export const RESET_STUDENT_SIGNUP = 'RESET_STUDENT_SIGNUP';

export const SIGNUP = 'SIGNUP';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILED = 'SIGNUP_FAILED';

export const VERIFY_PHONE_SIGNUP = 'VERIFY_PHONE_SIGNUP';
export const VERIFY_PHONE_SIGNUP_SUCCESS = 'VERIFY_PHONE_SIGNUP_SUCCESS';
export const VERIFY_PHONE_SIGNUP_FAILURE = 'VERIFY_PHONE_SIGNUP_FAILURE';

export const GO_TO_SIGNUP_STAGE = 'GO_TO_SIGNUP_STAGE';

export const FETCH_REGION_PROVIDER = 'FETCH_REGION_PROVIDER';
export const FETCH_REGION_PROVIDER_SUCCESS = 'FETCH_REGION_PROVIDER_SUCCESS';

export const facebookSignup = ({ countryCode, userId, accessToken }) => ({
  type: FACEBOOK_SIGNUP,
  payload: {
    countryCode,
    userId,
    accessToken,
  },
});

export const facebookSignupSuccess = () => ({ type: FACEBOOK_SIGNUP_SUCCESS });

export const facebookSignupFailed = errorMessage => ({
  type: FACEBOOK_SIGNUP_FAILED,
  payload: {
    errorMessage,
  },
});

export const storeSignupInfo = signupInfo => ({
  type: STORE_SIGNUP_INFO,
  payload: {
    signupInfo,
  },
});

export const alterFacebookAuthType = () => ({ type: ALTER_FACEBOOK_AUTH_TYPE });

export const switchSignupRole = role => ({
  type: SWITCH_SIGNUP_ROLE,
  payload: {
    role,
  },
});

export const signup = ({
  region,
  email,
  countryCode,
  phoneNumber,
  password,
}) => ({
  type: SIGNUP,
  payload: {
    region,
    email,
    countryCode,
    phoneNumber,
    password,
  },
});

export const signupSuccess = ({ isStudent, isPhoneType }) => ({
  type: SIGNUP_SUCCESS,
  payload: {
    isStudent,
    isPhoneType,
  },
});

export const signupFailed = errorMessage => ({
  type: SIGNUP_FAILED,
  payload: {
    errorMessage,
  },
});

export const resetStudentSignup = () => ({ type: RESET_STUDENT_SIGNUP });

export const verifyPhoneSignup = ({ verificationCode }) => {
  return {
    type: VERIFY_PHONE_SIGNUP,
    payload: {
      verificationCode,
    },
  };
};

export const verifyPhoneSignupSuccess = payload => ({
  type: VERIFY_PHONE_SIGNUP_SUCCESS,
  payload,
});

export const verifyPhoneSignupFailure = errorMessage => ({
  type: VERIFY_PHONE_SIGNUP_FAILURE,
  payload: {
    errorMessage,
  },
});

export const goToSignupStage = stage => ({
  type: GO_TO_SIGNUP_STAGE,
  payload: {
    stage,
  },
});

export const fetchRegionProvider = region => ({
  type: FETCH_REGION_PROVIDER,
  payload: {
    region,
  },
});

export const fetchRegionProviderSuccess = ({
  providers,
  studentSignupAuthType,
}) => ({
  type: FETCH_REGION_PROVIDER_SUCCESS,
  payload: {
    providers,
    studentSignupAuthType,
  },
});

const INIT_STATE = {
  role: STUDENT,
  studentSignupAuthType: PHONE,
  tutorSignupAuthType: EMAIL,
  authType: PHONE,
  signupInfo: {
    username: '',
    email: '',
    countryCode: '',
    phoneNumber: '',
    region: '',
  }, // used to store signup info for step 1.
  studentSignupStage: AUTH_TYPE_SELECTION,
  loadingStatus: loadingState.EMPTY,
  errorMessage: '',
  updatePasswordStatus: loadingState.EMPTY,
  providers: [],
  verifyPhoneSignupLoadingStatus: loadingState.EMPTY,
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FACEBOOK_SIGNUP:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
        authType: authTypes.FACEBOOK_AUTH_TYPE,
      };
    case FACEBOOK_SIGNUP_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
      };
    case FACEBOOK_SIGNUP_FAILED:
      return {
        ...state,
        loadingStatus: loadingState.ERROR,
        errorMessage: action.payload.errorMessage,
      };
    case STORE_SIGNUP_INFO:
      return {
        ...state,
        signupInfo: action.payload.signupInfo,
      };
    case ALTER_FACEBOOK_AUTH_TYPE:
      return {
        ...state,
        authType: authTypes.FACEBOOK_AUTH_TYPE,
      };
    case SWITCH_SIGNUP_ROLE:
      return {
        ...state,
        role: action.payload.role,
      };
    case SIGNUP:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case SIGNUP_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
        ...(action.payload.isStudent && {
          studentSignupStage: action.payload.isPhoneType
            ? PHONE_VERIFICATION_INPUT
            : EMAIL_VERIFICATION_INFO,
        }),
      };
    case SIGNUP_FAILED:
      return {
        ...state,
        loadingStatus: loadingState.ERROR,
        errorMessage: action.payload.errorMessage,
      };
    case RESET_STUDENT_SIGNUP:
      return {
        ...INIT_STATE,
      };
    case GO_TO_SIGNUP_STAGE:
      return {
        ...state,
        studentSignupStage: action.payload.stage,
      };
    case FETCH_REGION_PROVIDER:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case FETCH_REGION_PROVIDER_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
        providers: action.payload.providers,
        studentSignupAuthType: action.payload.studentSignupAuthType,
      };
    case VERIFY_PHONE_SIGNUP:
      return {
        ...state,
        verifyPhoneSignupLoadingStatus: loadingState.LOADING,
      };
    case VERIFY_PHONE_SIGNUP_SUCCESS:
      return {
        ...state,
        verifyPhoneSignupLoadingStatus: loadingState.READY,
        studentSignupStage: VERIFICATION_SUCCEEDED,
      };
    case VERIFY_PHONE_SIGNUP_FAILURE:
      return {
        ...state,
        verifyPhoneSignupLoadingStatus: loadingState.ERROR,
      };
    default:
      return state;
  }
};

export default reducer;

// selectors
export const getAuthType = state => state.signup.authType;
export const getStudentSignupAuthType = state =>
  state.signup.studentSignupAuthType;
export const getTutorSignupAuthType = state => state.signup.tutorSignupAuthType;
export const getSignupRole = state => state.signup.role;
export const getSignupInfo = state => state.signup.signupInfo;
export const getErrorMessage = state => state.signup.errorMessage;
export const getLoadingStatus = state => state.signup.loadingStatus;
export const getStudentSignupStage = state => state.signup.studentSignupStage;
export const getUpdatePasswordStatus = state =>
  state.signup.updatePasswordStatus;
export const getSignupUsername = state => state.signup.signupInfo.username;
export const getSignupEmail = state => state.signup.signupInfo.email;
export const getSignupCountryCode = state =>
  state.signup.signupInfo.countryCode;
export const getSignupPhoneNumber = state =>
  state.signup.signupInfo.phoneNumber;
export const getSignupRegion = state => state.signup.signupInfo.region;
export const getAuthProviders = state => state.signup.providers;
export const getVerifyPhoneSignupLoadingStatus = state =>
  state.signup.verifyPhoneSignupLoadingStatus;



// WEBPACK FOOTER //
// ./app/redux/signup.js